import { Colors, Lightning, Router, Utils } from '@lightningjs/sdk';
import { InputField } from '@lightningjs/ui';
import { authenticateUser } from '../../../api/users';
import { Input } from '@lightningjs/ui-components';

// Components
import { keyboardConfig } from '../components/keyboardConfig';
import Border from '../components/InputField';
import Button from '../components/Button';
import { Column } from '@lightningjs/ui-components';
import VisibleButton from './components/VisibleButton';
import Keyboard from '../../../components/Keyboard/components/Keyboard';

let inputFieldPass = 0;
export default class PasswordLogin extends Lightning.Component {
  static _template() {
    return {
      Logo: {
        x: 730,
        y: 170,
        w: 470,
        h: 67,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 470, 67),
      },
      Title: {
        x: 595,
        y: 283,
        w: 730,
        h: 88,
        text: {
          text: 'Enter your password',
          textColor: Colors('#fafafa').get(),
          fontFace: 'OpenSans-SemiBold',
          fontSize: 63,
          lineHeight: 78,
          textAlign: 'center',
        },
      },
      InputWrapper: {
        flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },

        InputContainer: {
          x: 613,
          y: 420,
          w: 695,
          h: 67,
          rect: true,
          color: Colors('#D6D6D6').get(),
          shader: { type: Lightning.shaders.RoundedRectangle, radius: 15 },
          Border: {
            type: Border,
          },
          InputField: {
            w: 695,
            h: 67,
            Input: {
              type: Input,
              y: 5,
              x: 5,
              w: 685,
              h: 57,
              mask: '*',
              password: true,
              listening: false,
              style: {
                backgroundColor: Colors('#D6D6D6').alpha(1).get(),
                textStyle: {
                  textColor: Colors('#444444').alpha(1).get(),
                  fontSize: 33,
                  fontFace: 'OpenSans-Regular',
                },
                cursorStyle: {
                  textColor: Colors('#444444').alpha(1).get(),
                },
              },
            },
          },
        },
        VisibleButton: {
          collision: true,
          type: VisibleButton,
        },
        Placeholder: {
          w: 600,
          h: 67,
          y: 430,
          x: -50,
          text: { text: 'Password', fontSize: 33, fontFace: 'OpenSans-Regular' },
          color: Colors('#444444').get(),
        },
      },
      BtnContainer: {
        x: 683,
        y: 530,
        w: 556,
        h: 75,
        rect: true,
        color: Colors('#292929').get(),
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 15 },
        LogInBtn: {
          w: 556,
          h: 70,
          collision: true,
          type: Button,
          InputText: {
            x: 232,
            y: 15,
            text: {
              text: 'Login',
              textColor: Colors('#ffffff').get(),
              fontFace: 'OpenSans-Regular',
              fontSize: 33,
              lineHeight: 40,
            },
          },
        },
      },
      Keyboard: {
        type: Keyboard,
        y: 650,
        w: 1920,
        rect: true,
        color: Colors('#000000').alpha(0).get(),
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        visible: false,
        limit: 50,
      },
      InvalidUsernameOrPassword: {},
    };
  }

  set params({ email }) {
    return (this._params = { email });
  }

  onInputChanged({ input }) {
    this._input = input;
    inputFieldPass = input.length;
    // const inputFieldText = input.length > 0 ? '*'.repeat(input.length) : 'Password';
    const inputFieldText = input.length > 0 ? input : 'Password';
    const inputTextComponent = this.tag('InputField.Input');
    if (input.length <= 0) {
      inputTextComponent.patch({
        text: {
          textColor: Colors('#444444').get(),
          text: 'Password',
          fontFamily: 'OpenSans-Regular',
          fontSize: 33,
        },
      });
    } else if (input.length >= 0) {
      inputTextComponent.patch({
        text: {
          textColor: Colors('#444444').get(),
          text: '',
          fontFamily: 'OpenSans-Regular',
          fontSize: 33,
        },
      });
    }
  }

  _firstActive() {
    this._input = undefined;
    this._setState('InputField');
    this.tag('InputField.Input').patch({
      text: {
        textColor: Colors('#444444').get(),
        text: 'Password',
        fontFamily: 'OpenSans-Regular',
        fontSize: 33,
      },
    });
  }
  $setState(state) {
    if (state === 'ContinueBtn') {
      this._setState('LogInBtn');
      this.$removeInputListe();
      return;
    }
    this._setState(state);
    if (
      (state == 'ContinueBtn' || state == 'InputField' || state == 'VisibleButton') &&
      this.tag('Keyboard').visible
    ) {
      this.$removeInputListe();
    }
  }
  _active() {
    this.tag('InvalidUsernameOrPassword').patch({
      text: '',
    });
  }
  _changePlaceholder() {
    const isInputEmpty = this._InputField.tag('Input').value === '';
    this.tag('Placeholder').patch({
      visible: isInputEmpty,
    });
  }

  $addInputListen() {
    this._InputField.tag('Input').listening = true;
  }

  $removeInputListe() {
    this._InputField.tag('Input').listening = false;
  }

  _handleBack() {
    if (this.tag('Keyboard').visible) {
      this.tag('Keyboard').visible = false;
      this._setState('InputField');
      this._InputField.tag('Input').listening = false;
    } else {
      Router.back();
    }
  }

  get _LogInBtn() {
    return this.tag('LogInBtn');
  }

  get _InputField() {
    return this.tag('InputField');
  }

  static _states() {
    return [
      class InputField extends this {
        _getFocused() {
          return this.tag('InputContainer.Border');
        }

        _handleDown() {
          this._setState('LogInBtn');
        }

        _handleRight() {
          this._setState('VisibleButton');
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleEnter() {
          this.$addInputListen();

          this.tag('Keyboard').visible = true;
          this._setState('Keyboard');
          this.tag('InputField.Input').patch({
            text: {
              text: inputFieldPass < 1 ? 'Password' : '',
            },
          });
        }
      },
      class VisibleButton extends this {
        _getFocused() {
          return this.tag('VisibleButton');
        }
        _handleLeft() {
          this._setState('InputField');
        }
        _handleDown() {
          this._setState('LogInBtn');
        }
        _handleClick() {
          this._handleEnter();
        }

        _handleEnter() {
          let passwordMode = this.tag('Input').password;
          let inputText = this.tag('Input').text.text;
          if (passwordMode) {
            this.tag('Input').patch({
              password: false,
            });
          } else {
            this.tag('Input').patch({
              password: true,
            });
          }
          this.tag('VisibleButton')._changeIcon(passwordMode);
        }
      },
      class LogInBtn extends this {
        _getFocused() {
          return this.tag('LogInBtn');
        }

        _handleUp() {
          this._setState('InputField');
        }

        _handleDown() {
          if (this.tag('Keyboard').visible) {
            this._setState('Keyboard');
          }
        }
        _handleClick() {
          this._handleEnter();
        }

        _handleEnter() {
          if (
            this._InputField.tag('Input').value === undefined ||
            this._InputField.tag('Input').value.length < 8
          ) {
            this.tag('InvalidUsernameOrPassword').patch({
              x: 735,
              y: 650,
              color: Colors('#ff0000').get(),
              text: {
                text: 'The password must be at least 8 characters long.',
                fontSize: 21,
              },
            });
          } else {
            const email = this._params.email;
            const password = this._InputField.tag('Input').value;
            // Pass a callback function to handle the error message UI update
            authenticateUser(email, password, (errorMessage) => {
              if (!errorMessage) {
              } else {
                // Update the UI with the error message
                this.tag('InvalidUsernameOrPassword').patch({
                  x: 820,
                  y: 650,
                  color: Colors('#ff0000').get(),
                  text: {
                    text: 'Invalid username or password',
                    fontSize: 21,
                  },
                });
              }
            });
          }
        }
      },

      class Keyboard extends this {
        _getFocused() {
          this.$addInputListen();
          return this.tag('Keyboard');
        }

        _handleUp() {
          this._setState('LogInBtn');
          this.tag('Keyboard').visible = false;
          this._InputField.tag('Input').listening = false;
        }
      },
    ];
  }
}
